<section
  class="destination-selector-container"
  [class.destination-selector-container-t2]="theme() === GbTheme.ThemeTwo"
>
  <div class="container">
    <div class="buttons-row" [class.buttons-row-t2]="theme() === GbTheme.ThemeTwo">
      <div class="buttons-container-wrapper">
        <div class="buttons-container">
          <app-toggle
            [leftValue]="'Countries'"
            [rightValue]="'Regions'"
            [leftHref]="'/countries'"
            [rightHref]="'/regions'"
            [(value)]="selectedDestination"
            class="toggle-t2"
          >
            <span left>{{ 'buy_plan.destination.countries' | translate }}</span>
            <span right>{{ 'buy_plan.destination.regions' | translate }}</span>
          </app-toggle>

          <!-- Desktop Search (above button) -->
          <div
            class="d-none"
            [class.d-sm-block]="theme() === GbTheme.ThemeTwo"
            [class.d-md-block]="theme() === GbTheme.ThemeOne"
            [class.w-100]="theme() === GbTheme.ThemeTwo"
          >
            <app-animated-search
              [placeholder]="
                selectedDestination() === 'Countries'
                  ? ('buy_plan.destination.search_countries' | translate)
                  : ('buy_plan.destination.search_regions' | translate)
              "
              [items]="selectedDestination() === 'Countries' ? allCountries() : regions()"
              (itemSelected)="
                selectedDestination() === 'Countries'
                  ? onCountrySelected($any($event))
                  : onRegionSelected($any($event))
              "
            />
          </div>

          <button
            class="primary-button rounded-pill search-button flex-center"
            [class.d-sm-none]="theme() === GbTheme.ThemeTwo"
            [class.d-md-none]="theme() === GbTheme.ThemeOne"
            (click)="toggleMobileSearch()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15.0297 15.0258L19.0527 19.0488M0.949219 8.99129C0.949219 11.1252 1.79692 13.1717 3.30583 14.6807C4.81474 16.1896 6.86127 17.0373 8.9952 17.0373C11.1291 17.0373 13.1756 16.1896 14.6846 14.6807C16.1935 13.1717 17.0412 11.1252 17.0412 8.99129C17.0412 6.85736 16.1935 4.81084 14.6846 3.30192C13.1756 1.79301 11.1291 0.945313 8.9952 0.945312C6.86127 0.945313 4.81474 1.79301 3.30583 3.30192C1.79692 4.81084 0.949219 6.85736 0.949219 8.99129Z"
                stroke="white"
                stroke-width="1.72414"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <!-- Mobile Search (below button) -->
        <div class="d-md-none w-100" [class.d-none]="isSearchActiveForMobile()">
          <app-animated-search
            [placeholder]="
              selectedDestination() === 'Countries'
                ? ('buy_plan.destination.search_countries' | translate)
                : ('buy_plan.destination.search_regions' | translate)
            "
            [items]="selectedDestination() === 'Countries' ? allCountries() : regions()"
            (itemSelected)="
              selectedDestination() === 'Countries'
                ? onCountrySelected($any($event))
                : onRegionSelected($any($event))
            "
            [isMobileSearchActive]="isSearchActiveForMobile()"
            [isMobileView]="true"
          />
        </div>
      </div>

      <div class="buttons-container" [class.explore-only]="selectedDestination() === 'Regions'">
        @if (hasGlobalRegionSlug()) {
          <a
             [href]="'/' + globalRegions()[0].slug"
            class="primary-button custom-button primary-font-semibold explore-button flex-center"
            (click)="$event.preventDefault(); exploreGlobalPlans()"
            [class.rounded-pill]="theme() === GbTheme.ThemeOne"
          >
            {{ 'buy_plan.destination.explore_global_plans' | translate }}
            <app-arrow [svgClass]="'explore-global-plans-btn-arrow'"></app-arrow>
          </a>
        }

        @if (selectedDestination() === 'Countries') {
          <button
            class="primary-button rounded-pill custom-button primary-font-semibold view-all-button flex-center d-md-none"
            [class.rounded-pill]="theme() === GbTheme.ThemeOne"
            [class.d-none]="theme() === GbTheme.ThemeTwo"
            (click)="viewAll()"
          >
            {{ 'buy_plan.destination.view_all' | translate }}
          </button>
        }
      </div>
    </div>

    @if (selectedDestination() === 'Countries') {
      <div class="row country-region-row">
        @for (country of countries(); track country._id) {
          @if (country.plans.length > 0) {
            <div
              class="country-region-item"
              [class.seo-links-hidden]="!country.isPopular"
              [attr.aria-hidden]="!country.isPopular ? 'true' : null"
              [class.col-6]="theme() === GbTheme.ThemeOne"
              [class.col-sm-4]="theme() === GbTheme.ThemeOne"
              [class.col-md-3]="theme() === GbTheme.ThemeOne"
              [class.col-md-4]="theme() === GbTheme.ThemeTwo"
              [class.col-sm-6]="theme() === GbTheme.ThemeTwo"
              [class.col-12]="theme() === GbTheme.ThemeTwo"
            >
              <app-country
                [country]="country"
                (keydown.enter)="onCountrySelected(country)"
                [tabIndex]="country.isPopular ? null : -1"
                (click)="onCountrySelected(country)"
              />
            </div>
          }
        }
      </div>
    }

    @if (selectedDestination() === 'Regions') {
      <div class="row country-region-row">
        @for (region of regions(); track region._id) {
          @if (region.plans.length > 0) {
            <div
              [class.col-6]="theme() === GbTheme.ThemeOne"
              [class.col-sm-4]="theme() === GbTheme.ThemeOne"
              [class.col-md-3]="theme() === GbTheme.ThemeOne"
              [class.col-md-4]="theme() === GbTheme.ThemeTwo"
              [class.col-sm-6]="theme() === GbTheme.ThemeTwo"
              [class.col-12]="theme() === GbTheme.ThemeTwo"
            >
              <app-region
                [region]="region"
                (click)="onRegionSelected(region)"
                (keydown.enter)="onRegionSelected(region)"
              />
            </div>
          }
        }
      </div>
    }

    @if (selectedDestination() === 'Countries') {
      <div
        class="view-all-button-container"
        [class.d-none]="theme() === GbTheme.ThemeOne"
        [class.d-md-flex]="theme() === GbTheme.ThemeOne"
      >
        <button
          class="primary-button custom-button primary-font-semibold view-all-button"
          (click)="viewAll()"
          [class.rounded-pill]="theme() === GbTheme.ThemeOne"
          [class.view-all-button-t2]="theme() === GbTheme.ThemeTwo"
        >
          {{ 'buy_plan.destination.view_all' | translate }}
        </button>
      </div>
    }
  </div>
</section>
